// export const baseURL = "https://exp5876.uta.cloud/php/";

export const baseURL = "https://exp5876.uta.cloud/api/";

// export const baseURL = "http://localhost:80/student_marketplace/";

// export const baseURL = "http://127.0.0.1:8000/api/";
